export function initGalleryTabs() {
    const tabs = document.querySelectorAll('.gallery__tab');
    const panels = document.querySelectorAll('[data-tab-panel]');

    if (!tabs.length || !panels.length) return;

    tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
            const target = tab.dataset.tabTarget;

            tabs.forEach((t) => {
                const isActive = t === tab;
                t.classList.toggle('is-active', isActive);
                t.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });

            panels.forEach((panel) => {
                panel.toggleAttribute('hidden', panel.dataset.tabPanel !== target);
            });
        });
    });
}
